import { render } from "./HRIS.vue?vue&type=template&id=60dc72ea"
import script from "./HRIS.vue?vue&type=script&lang=js"
export * from "./HRIS.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\versatech_vex\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__